import {h, Fragment} from "preact"
import { useAppState, AutocompleteElement } from '@nosto/preact'
import { useEffect, useState, useMemo } from 'preact/hooks'
import { formatCurrency, getProductByHandle } from '../helpers'
import { isFrench } from '../config'

function reviewsArray(number) {
    var array = [];
    for (var i = 0; i < 5; i++) {
        if (number >= 1) {
            array.push('full');
            number -= 1;
        } else if (number >= 0.8) {
            array.push('full');
            number -= 0.8;
        } else if (number >= 0.4) {
            array.push('half');
            number -= 0.4;
        } else {
            array.push('empty');
            number = 0;
        }
    }
    return array;
}

export default ({ product, addToCart }) => {
    const { response: { products } } = useAppState()
    const [ hoverImg, setHoverImg ] = useState(null);
    const [ scents, setScents ] = useState(null);
    const [ badge, setBadge ] = useState(null);
    const [ award, setAward ] = useState(null);
    const [ isKit, setIsKit ] = useState(false);
    const [ reviews, setReviews ] = useState({});
    const handle = useMemo(() => product.url.split('/products/')[1], []);
    const forcePdpAtc = useMemo(() => !!(product.customFields?.find(field => field.key === "custom-force_pdp_atc" && field.value === "true")), []);
    const isVoyages = useMemo(() => product.tags1?.includes('Voyages'), [])

    useEffect(() => {
        if (product.customFields.find(field => field.key === 'yotpo-richsnippetshtml')) {
            const reviewField = product.customFields.find(field => field.key === 'yotpo-richsnippetshtml').value.split(' Reviews ');
            const rating = Number(reviewField[1].replace('( ', '').replace(' )', ''));
            const reviews = {
                rating,
                stars: reviewsArray(rating),
                total: reviewField[0],
            }
            setReviews(reviews);
        }

        getProductByHandle(handle)
            .then(res => {
                const responseImage = res.data?.productByHandle?.productCardHoverImage?.reference?.image?.url;
                setHoverImg(responseImage);
                
                const awardsObj = res.data?.productByHandle?.awardBadge?.reference?.fields?.find(field => !!field?.reference)?.reference?.image;
                setAward(awardsObj)

                const responseBadge = res.data?.productByHandle?.standardBadge?.reference?.fields?.reduce((obj, field) => {
                    obj[field.key] = field.value;
                    return obj;
                }, {})
                setBadge(responseBadge);
                
                const responseScents = res.data?.productByHandle?.scentColors?.references?.edges?.map(scent => {
                    const hex = scent.node.fields.find(field => field.key === 'color').value;
                    const color = scent.node.fields.find(field => field.key === 'color_text').value;
                    return { hex, color };
                });
                setScents(responseScents);

                setIsKit((res.data?.productByHandle?.kitOptionGroup1?.references?.nodes?.length > 0))
            })
    }, [product])

    return (
        <AutocompleteElement
            hit={product}
        >
            <div class={`relative bg-cream-grey group h-full ${isVoyages ? 'ns-voyages' : ''}`} data-product-card="true">
                {/* Desktop Hover Details */}
                <div class="hidden relative laptop:group-hover:block">
                    <a href={product.url} class="h-full relative block link-unstyled pt-[80%] !h-0">
                        {hoverImg
                            ?   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${hoverImg.replace('.jpg', '_326x.jpg')} 326w, ${hoverImg.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px"src={hoverImg} alt={product.name} loading="lazy" />
                            :   product.alternateImageUrls && product.alternateImageUrls.length > 0
                                ?   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${product.alternateImageUrls[0]?.replace('.jpg', '_326x.jpg')} 326w, ${product.alternateImageUrls[0]?.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={product.alternateImageUrls[0]} alt={product.name} loading="lazy" />
                                :   <img class="image block w-full absolute top-0 left-0 h-full object-cover" srcset={`${product.imageUrl?.replace('.jpg', '_326x.jpg')} 326w, ${product.imageUrl?.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={product.imageUrl} alt={product.name} loading="lazy" />
                        }
                    </a>
                    <div class="absolute bottom-2.5 left-2.5 max-w-[calc(100%-20px)] w-full z-[5]">
                        <div class="flex items-center justify-start gap-[7.8px]">
                            {product.availability === 'OutOfStock'
                                ?   <button type="submit" class="btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between" disabled>
                                        <span>Out of Stock</span>
                                        <div class="justify-start flex gap-2.5">
                                            <span class="cta-large">{formatCurrency(product.price)}</span>
                                            {product.listPrice && product.listPrice > product.price && <del class="cta-large text-white">{formatCurrency(product.listPrice)}</del>}
                                        </div>
                                    </button>
                                : forcePdpAtc
                                    ?   <a href={product.url} class="prod-link btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between">
                                            <span>{isFrench ? "Voir le produit" : "View Product"}</span>
                                        </a>
                                    :   isKit
                                        ?   <a href={product.url} class="hover:no-bg btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between">
                                                <span>{isFrench ? 'Sélectionner les produits' : 'Select Products'}</span>
                                            </a>
                                        :   <button 
                                                type="button" 
                                                class="btn-primary cta-large py-[14.5px] w-full transition-all hover:!border-charcoal hover:bg-charcoal hover:!text-white flex items-center justify-between" 
                                                onClick={(e) => { 
                                                    e.preventDefault();
                                                    e.stopImmediatePropagation();
                                                    addToCart(product); 
                                                }}
                                            >
                                                <span>{isFrench ? 'Ajouter au panier' : 'Add to Bag'}</span>
                                                <div class="justify-start flex gap-2.5">
                                                    <span class="cta-large">{formatCurrency(product.price)}</span>
                                                    {product.listPrice && product.listPrice > product.price && <del class="cta-large text-white">{formatCurrency(product.listPrice)}</del>}
                                                </div>
                                            </button>
                            }
                        </div>
                    </div>
                </div>
                {/* Main Product Details */}
                <div class="block prod-details">
                    <a href={product.url} class="h-0 relative pt-[80%] block link-unstyled laptop:group-hover:hidden">
                        {(badge || award) &&
                            <div class={`flex ${award && !badge ? 'justify-end' : 'justify-between'} absolute z-[3] top-[5px] laptop:top-2.5 laptop:left-2.5 left-[5px] items-start laptop:w-[calc(100%-20px)] w-[calc(100%-10px)] laptop:group-hover:hidden`}>
                                {badge && <p class="text-black bg-white laptop:px-2.5 px-2 py-[5px] laptop:py-2 font-badge-card" style={`background-color: ${badge['background_color']}; color: ${badge['text_color']};`}>{badge['badge_text']}</p>}
                                {award && <img class="prod-award" src={award.url} alt={award.altText} />}
                            </div>
                        }
                        <img class={`image block w-full absolute top-0 left-0 h-full object-cover z-[2] ${(product.imageUrl?.includes('white-background') || product.imageUrl?.includes('white_background')) ? 'mix-blend-multiply' : ''}`} srcset={`${product.imageUrl?.replace('.jpg', '_326x.jpg')} 326w, ${product.imageUrl?.replace('.jpg', '_650x.jpg')} 650w`} sizes="(max-width: 640px) 326px, 650px" src={product.imageUrl} alt={product.name} loading="lazy"/>
                    </a>
                    <div class="ns-prod-footer flex flex-col p-3 pt-0">
                        {!isVoyages && (
                            <div class="flex items-center justify-start gap-[2.35px] mb-3 pt-3 border-t border-black-30">
                                {/* <div class="yotpo bottomLine yotpo-small" data-product-id={product.productId}></div> */}
                                {(reviews?.total && reviews?.rating && reviews?.stars) &&
                                    <div class="yotpo bottomLine yotpo-small">
                                        <div class="yotpo-display-wrapper" style="visibility: hidden;">
                                            <div class="standalone-bottomline" data-source="default" tabindex="-1">
                                                <div class="yotpo-bottomline pull-left  star-clickable" tabindex="0">
                                                    <span class="yotpo-stars">
                                                        {reviews?.stars.map((s) => (
                                                            s === 'half'
                                                                ?   <span class="yotpo-icon yotpo-icon-half-star rating-star pull-left"></span>
                                                                : s === 'empty'
                                                                    ?   <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span>
                                                                    :   <span class="yotpo-icon yotpo-icon-star rating-star pull-left"></span>
                                                        ))}
                                                        <span class="sr-only">{reviews?.rating} star rating</span>
                                                    </span>
                                                    <p class="text-m" aria-label={`${reviews?.total} reviews`} tabindex="-1">{reviews?.total} Reviews</p>   
                                                    <div class="yotpo-clr"></div>
                                                </div>
                                                <div class="yotpo-clr"></div>
                                            </div>
                                            <div class="yotpo-clr"></div>
                                        </div>
                                    </div>
                                }
                            </div>
                        )}
                        {scents && 
                            <div class="flex items-center justify-start gap-[14px] mb-2">
                                {scents.map((s) => (<div class="flex items-center justify-start gap-[6px]">
                                    <span class="w-2 h-2 rounded-[50px] inline-block" style={`background-color: ${s.hex};`}></span>
                                    <span class="utility-1 text-charcoal capitalize tracking-[1px]">{s.color}</span>
                                </div>)
                                )}
                            </div>
                        }
                        <div class="mb-2">
                            <a href={product.url} class="text-black font-14">{product.name}</a>
                        </div>
                        <div class="justify-start flex gap-2.5">
                            <span class="font-13 text-charcoal">{formatCurrency(product.price)}</span>
                            {product.listPrice && product.listPrice > product.price && <del class="font-13 text-grey-60">{formatCurrency(product.listPrice)}</del>}
                        </div>
                    </div>
                </div>
            </div>
        </AutocompleteElement>
    )
}
